import React, { useEffect, useRef, useLayoutEffect, useState } from "react";
import {
  BrowserRouter as Router, Route, Routes, useLocation,
  useNavigationType
} from "react-router-dom";



import Layout from "./components/Layout/Layout";
import Home from "./components/HomeComponent/Home";
import MainCategory from "./components/HomeComponent/MainCategory";

// Listpages
import ProductList from "./components/ProductList/ProductList";
import BrandList from "./components/ProductList/BrandList";
import OfferList from "./components/ProductList/OfferList";
import SubSubCatProductList from "./components/ProductList/SubSubCatProductList"

// ProductDetails
import ProductDetails from "./components/ProductDetails/ProductDetails";

//Cart
import Cart from "./components/Cart/Cart";
import Checkout from "./components/Checkout/Checkout";
import PaymentPage from "./components/Payment/PaymentPage";


//404 page not found
import NotFoundPage from "./components/404";
import ShopClosed from "./components/ShopClosed";

//DashBoard
import Dashboard from "./components/dashboard/Dashboard";

//legals
import AboutUs from "./components/Legals/AboutUs";
import Faq from "./components/Legals/Faq";
import TermsAndCondition from "./components/Legals/TermsAndCondition";
import PrivacyPolicy from "./components/Legals/PrivacyPolicy";
import ContactUs from "./components/Legals/ContactUs";

//chatbot
import ChatBot from "./components/ChatBot/ChatBot";






const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [pathname]);

  return null;
};

function App() {
  const [showModal, setShowModal] = useState(false);
  return (
    <>
      <Router>
        <ScrollToTop />
        <ChatBot />
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />

            <Route path="maincategory/:maincategory_auto_id" element={<MainCategory />} />

            <Route path="dashboard" element={<Dashboard />} />

            <Route path="productlist" element={<ProductList />} />
            <Route path="brandlist" element={<BrandList />} />
            <Route path="offerlist" element={<OfferList />} />
            <Route path="subsubcatproductlist" element={<SubSubCatProductList />} />

            <Route path="product-detail/:id" element={<ProductDetails />} />

            <Route path="cart" element={<Cart />} />
            <Route path="checkout" element={<Checkout />} />
            <Route path="paymentpage" element={<PaymentPage />} />

            <Route path="shop-closed" element={<ShopClosed />} />

            <Route path="aboutus" element={<AboutUs />} />
            <Route path="faq" element={<Faq />} />
            <Route path="termsandcondition" element={<TermsAndCondition />} />
            <Route path="privacyandpolicy" element={<PrivacyPolicy />} />
            <Route path="contact" element={<ContactUs />} />
          </Route>

          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Router>
    </>
  );
}

export default App;


